import { $t } from '@/i18n';
import { postEmail, notifyByWework } from './notification';
import { robotApi } from '@/services';
import { isEmpty } from 'lodash';
import { message } from '@utils/wuji-message';
import {
  XyRtxSelectorMeta,
  XyRobotSelectorMeta,
  XyWeworkMessageMeta,
  XyWxworkSelectorMeta,
  XyEmailSelectorMeta,
} from '../paramsFormComponents';
import { CATEGORY } from './const';
import stringInterop from '@tencent/ui-core/lib/utils/stringInterop';
import { ENABLE_EMAIL_SETTING, HAS_EMAIL_SERVICE } from '@/config/constant';

// 邮件通知
export const emailNotificationAtom = {
  id: 'xy:source:emailNotification',
  name: $t('k_c5052b21'),
  category: CATEGORY.NOTIFICATION,
  paramsSchema: {
    type: 'object',
    fields: [
      ...(ENABLE_EMAIL_SETTING ? [
        {
          id: 'emailId',
          type: 'string',
          title: $t('k_8776aed9'),
          default: '',
          ui: { type: 'XyEmailSelector' },
        },
      ] : []),
      {
        id: 'to',
        type: 'string',
        title: $t('k_87c972c2'),
        default: '',
        ui: { type: 'XyRtxSelector' },
      },
      {
        id: 'cc',
        type: 'string',
        title: $t('k_6b4bdb44'),
        default: '',
        ui: { type: 'XyRtxSelector' },
      },
      {
        id: 'bcc',
        type: 'string',
        title: $t('k_b4a66fa3'),
        default: '',
        ui: { type: 'XyRtxSelector' },
      },
      {
        id: 'title',
        type: 'string',
        title: $t('k_88ba6118'),
        default: '',
      },
      {
        id: 'content',
        type: 'string',
        title: $t('k_d8bbcc26'),
        default: '',
      },
    ],
  },
  paramsFormComponents: [
    XyRtxSelectorMeta,
    XyEmailSelectorMeta,
  ],
  async execute(ctx, params) {
    const { to, cc = '', bcc = '', title, content, emailId = '' } = params;
    if (!to || !title || !content) {
      throw new Error($t('k_ce65f7d'));
    }

    await postEmail(to, title, content, { cc, bcc, emailId });
  },
};
// 企微机器人通知
export const robotNotificationAtom = {
  id: 'xy:source:robotNotification',
  name: $t('k_6a73fffe'),
  category: CATEGORY.NOTIFICATION,
  desc: $t('k_24609626'),
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'robotId',
        type: 'string',
        title: $t('k_74aa8f66'),
        ui: { type: 'XyRobotSelector' },
      },
      {
        id: 'data',
        type: 'string',
        title: $t('k_27231ac8'),
        description: '',
        default: JSON.stringify({ msgtype: 'text', text: { content: 'hello {{w.user.userId}}' } }, null, 2),
      },
      {
        id: 'successNotice',
        type: 'boolean',
        title: $t('k_d668b27'),
        default: true,
      },
    ],
  },
  async execute(ctx, params) {
    const { projectId, env } = window.w;
    const { robotId, successNotice } = params;
    if (!robotId || !params.data) {
      const msg = $t('k_992d2e52');
      throw new Error(msg);
    }
    let data = null;
    try {
      if (typeof params.data === 'string') data = JSON.parse(params.data);
      else data = params.data;
    } catch (error) {
      const msg = $t('k_b2c30c5e');
      throw new Error(msg);
    }
    try {
      await robotApi.postRobotMessage(projectId, env, robotId, data);
      successNotice && message.success($t('k_130d0afe'));
    } catch (error) {
      const msg = $t('k_d6c2487a');
      throw new Error(msg);
    }
  },
  paramsFormComponents: [
    XyRobotSelectorMeta,
  ],
};
// 企业微信通知
export const weworkNotificationAtom = {
  id: 'xy:source:weworkNotification',
  name: $t('k_76deb9d2'),
  category: CATEGORY.NOTIFICATION,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'weworkMsgConfig',
        type: 'object',
        title: $t('k_7c7b63c2'),
        'uc:allowInterop': true,
        ui: { type: 'XyWeworkMessage' },
        fields: [
          {
            id: 'weworkApp',
            title: $t('k_c87204a1'),
            type: 'string',
            default: '',
          },
          {
            id: 'receiverType',
            title: $t('k_cd6d0115'),
            type: 'string',
            default: 'dynamic',
          },
          {
            id: 'receivers',
            title: $t('k_7fef35c1'),
            type: 'string',
            default: '',
          },
          {
            id: 'msgType',
            title: $t('k_30075892'),
            type: 'string',
            default: 'text',
          },
          {
            id: 'content',
            title: $t('k_389afe34'),
            type: 'string',
            default: '',
          },
          {
            id: 'title',
            title: $t('k_10eb0273'),
            type: 'string',
            default: '',
          },
          {
            id: 'description',
            title: $t('k_389afe34'),
            type: 'string',
            default: '',
          },
          {
            id: 'url',
            title: $t('k_e9edcb6b'),
            type: 'string',
            default: '',
          },
          {
            id: 'btnTxt',
            title: $t('k_4e9ddf9c'),
            type: 'string',
            default: $t('k_25b5db1'),
          },
        ],
      },
    ],
  },
  paramsFormComponents: [
    XyWeworkMessageMeta,
  ],
  async execute(ctx, params) {
    const {
      weworkApp,
      receivers, msgType, content, title, description, url, btnTxt } = params.weworkMsgConfig || {};
    if (isEmpty(receivers)) {
      throw new Error($t('k_1ddf7efa'));
    }
    if (msgType === 'text') {
      if (!content) {
        throw new Error($t('k_6e6ce56f'));
      }
    } else if (msgType === 'markdown') {
      if (!content) {
        throw new Error($t('k_64cd4e72'));
      }
    } else {
      if (!title || !description || !url || !btnTxt) {
        throw new Error($t('k_bcb0cb20'));
      }
    }

    const receiverList = typeof receivers === 'string' ? receivers.split(/[ ,;]/g).filter(Boolean) : receivers;
    const data = { receivers: receiverList, msgType };
    data.data = ['text', 'markdown'].includes(msgType) ? { content } : { title, description, url, btntxt: btnTxt };
    const { projectId, env } = window.w;

    const builtin = weworkApp === 'builtin';
    await notifyByWework(projectId, env, data, builtin);
    message.success($t('k_7e3d2d55'));
  },
};
// 唤起企业微信
export const messageAtom = {
  id: 'xyEvent:wxwork:message',
  name: $t('k_6ebe5600'),
  category: CATEGORY.NOTIFICATION,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'messageConfig',
        title: $t('k_c85e61eb'),
        type: 'object',
        ui: { type: 'XyWxworkSelector' },
        fields: [
          {
            id: 'type',
            title: $t('k_8fc3cc81'),
            type: 'string',
            default: 'username',
          },
          {
            id: 'username',
            title: $t('k_26612844'),
            type: 'string',
            default: '',
          },
          {
            id: 'usernameExpr',
            title: $t('k_78c9f6ed'),
            type: 'string',
            default: '',
          },
          {
            id: 'uin',
            title: $t('k_262dd001'),
            type: 'string',
            default: '',
          },
        ],
      },
    ],
  },
  paramsFormComponents: [
    XyWxworkSelectorMeta,
  ],
  async execute(ctx, params) {
    const { type, username, usernameExpr, uin } = (params?.messageConfig ?? {});
    let typeValue;
    if (type === 'username') {
      typeValue = username;
      if (!username) {
        throw new Error($t('k_c0a669ff'));
      }
    }
    if (type === 'usernameExpr') {
      typeValue = stringInterop(usernameExpr, ctx.renderer);
      if (!typeValue) {
        throw new Error($t('k_c0a669ff'));
      }
    }
    if (type === 'uin') {
      typeValue = stringInterop(uin, ctx.renderer);
      if (!typeValue) {
        throw new Error($t('k_5637b420'));
      }
    }
    if (typeValue) {
      typeValue = String(typeValue).replace(/\s*[，；、,]\s*/g, ';')
        .trim();
      const openType = type === 'usernameExpr' ? 'username' : type;
      window.open(`wxwork://message.com/?${openType}=${typeValue}`, '_blank');
    };
  },
};

export default [
  ...(HAS_EMAIL_SERVICE ? [emailNotificationAtom] : []),
  robotNotificationAtom,
  weworkNotificationAtom,
  messageAtom,
];
